import { render, staticRenderFns } from "./SpeakerNewsCard.vue?vue&type=template&id=4ab093fd&scoped=true&"
import script from "./SpeakerNewsCard.vue?vue&type=script&lang=js&"
export * from "./SpeakerNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerNewsCard.vue?vue&type=style&index=0&id=4ab093fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab093fd",
  null
  
)

export default component.exports